<template>
  <a-modal v-model:visible="RechargeVisible" :title="$t('_st._sqhk')" :footer="null" :style="{ width: '600px' }">
    <div :style="{ padding: '0 20px' }">
      <a-form :model="params" name="basic" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }" autocomplete="off" @finish="onFinish">
        <!-- type -->
        <a-form-item :label="$t('_st._yjk')" name="type"> $ {{ total }} </a-form-item>
        <!-- type -->
        <a-form-item :label="$t('_st._hkfs')" name="type">
          <a-radio-group v-model:value="params.type">
            <a-radio :value="2">{{ $t('_st._czhk') }}</a-radio>
          </a-radio-group>
        </a-form-item>
        <!-- number -->
        <a-form-item :label="$t('_st._hkje')" name="amount">
          <a-input-group compact>
            <a-input v-model:value="params.amount" prefix="$" type="number" :step="0.01" :placeholder="$t('_st._qrshkje')" style="width: calc(100% - 100px)" />
            <a-button @click="onAll()"> {{$t('_st._qb')}} </a-button>
          </a-input-group>
        </a-form-item>
        <!-- 备注 -->
        <!-- <a-form-item :label="$t('withdrawal.notice')" name="username" :label-col="{ span: 4 }" :wrapper-col="{ span: 17 }">
          <div style="padding: 5px 0; line-height: 23px; color: #999">
            <div>{{ $t('withdrawal.notice.text') }}</div>
          </div>
        </a-form-item> -->
        <a-form-item :wrapper-col="{ offset: 10, span: 16 }">
          <a-button type="primary" html-type="submit" :loading="btnLoad">{{ $t('_st._ljsq') }}</a-button>
          <!-- <a-button style="margin-left: 10px" @click="hide()">{{ $t('recharge.cancel.text') }}</a-button> -->
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'RechargeVue',
  props: {
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      //加载按钮
      btnLoad: false,
      RechargeVisible: false,

      params: {
        type: 2,
        amount: ''
      }
    }
  },
  created() {},
  methods: {
    onAll() {
      this.params.amount = this.total
    },
    /**
     * 存币
     */
    show() {
      this.params.amount = ''
      this.RechargeVisible = true
    },
    hide() {
      this.RechargeVisible = false
    },
    /**
     * 提交提现
     * @param {*} values
     */
    onFinish(values) {
      console.log('params:', values)
      if (this.params.amount <= 0) {
        this.$message.error({ content: 'Please enter the repayment amount' })
        return
      }

      //参数
      this.btnLoad = true
      this.$message.loading({ content: 'Submit repayment...', key: 'msg' })

      let that = this
      this.$api.finance
        .repayment(values)
        .then((res) => {
          that.btnLoad = false
          that.$message.success({
            content: res.msg,
            key: 'msg'
          })

          //关闭弹窗，重新刷新
          that.hide()
          that.$emit('Success')
        })
        .catch(() => {
          that.btnLoad = false
        })
    }
  }
}
</script>

<style>
.wallet-title {
  margin-right: 5px;
  font-weight: 700;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
